import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateProduct } from "./createProduct.request";
import { CreateProductResponseData } from "./createProduct.types";

const useCreateProduct = (
  options?: MutationOptions<
    CreateProductResponseData,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestCreateProduct,
    ...options
  });
};

export default useCreateProduct;
